
	import { Component, Vue } from 'vue-property-decorator'
	import BaseVue from '@/components/BaseVue'
	import appBar from '@/components/AppBar.vue'
	import { EditCondition } from '../models/EmpPasswordCondition'
    import { StationInput } from '../models/StationInput'
	import confirmDialog from '@/components/ConfirmDialog.vue'
	import BlockUI from '@/components/BlockUI.vue'
    import StationTextField from '@/components/StationTextField.vue';

    @Component({
        components: { appBar, confirmDialog, BlockUI, StationTextField }
})
export default class EmoloyeeMasterEditView extends BaseVue {
	//#region 変数

	private editCondition: EditCondition = new EditCondition()
	private eventNm = ''
	private showPassword = false
	private afterDelete = false
    private disableEmpCd = false

	private station: StationInput = {text:'', cd:''}

	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''
	//#endregion

    //#region ダイアログ
	private showConfirmDialog = false
	private showCostRequestDialog = false
    private dialog = false
    private title = ''
    private dialogMsg = ''
	//#endregion

    private uploadFileData: any
    //private uploadFile: any
	//#endregion

	//#region 初期表示イベント
	private async created() {
		this.editCondition.empCd = this.$route.params.empcd
		this.getEmp()

		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion

    private confirm() {
        this.dialog = false
    }

    private confirmResponse(res: boolean) {
        if (res) {
            //確認ダイアログで「はい」がおされた処理
            console.log('はい')
            null
        }
        else {
            //確認ダイアログで「いいえ」がおされた処理
            console.log('いいえ')
            null
        }
        this.showConfirmDialog = false
		}

	private costRequestResponse(res: boolean) {
        this.showCostRequestDialog = false
    }

    //#region BlockUIボタン押下
    private async clickBlockUI() {
        this.brockUIProcess(async () => {
            await new Promise(resolve => setTimeout(resolve, 5000))
        })
    }
	//#endregion

	//#region 保存ボタン押下
	private async save() {
		//メッセージクリア
		this.messageClear()

		const data = {
			EditCondition: this.editCondition
		}

		try {
			const response = await this.$axios.post('api/EmployeePasswordEdit/Edit', data)

			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				if (!response.data.messageData.errFlg) {
					this.getEmp()
				}
				//画面上部へスクロール
				window.scrollTo({ top: 0, behavior: 'smooth' })
				return
			}
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion

	//#endregion

	//#region 閉じるボタン押下
	private close() {
		this.$router.push({ name: 'Menu' })
	}
	//#endregion

	//#region 経費一覧画面（画面遷移)ボタン押下
        private showCostList() {
			this.$router.push({
				name: 'CostList',
				params: {
                    monthlyKbn: '0',
                }
			})
	}
	//#endregion
        

	//#region プライベート

	//#region 従業員情報取得
	private async getEmp() {
		try {
			const data = { EditCondition: this.editCondition }

			const response = await this.$axios.post('api/EmployeePasswordEdit/Get', data)

			this.editCondition = response.data.editCondition

		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion


	//#region メッセージクリア
	private messageClear() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

	//#endregion
}
